"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.createItem = exports.TYPE = void 0;
const translation_1 = require("../../../translation");
const id_1 = require("../../../utils/id");
exports.TYPE = 'tabs';
const createItem = () => ({
    value: (0, id_1.generateId)(),
    label: (0, translation_1.t)('elements.tab.item'),
});
exports.createItem = createItem;
exports.DEFAULT_VALUE = {
    items: [(0, exports.createItem)()],
};
